import LicenseDetail from './LicenseDetail';

export default LicenseDetail;
